import { render, staticRenderFns } from "./BasePublicationsParticipantsExpansionTable.vue?vue&type=template&id=f94b3400&"
import script from "./BasePublicationsParticipantsExpansionTable.vue?vue&type=script&lang=js&"
export * from "./BasePublicationsParticipantsExpansionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports